import cn from '@/lib/clsxm';

import Card from '@/components/@base/card';
import Container from '@/components/@base/container';
import Rate from '@/components/@base/rate';
import XImage from '@/components/@base/x-image';

import { DATA_CY_STORE_INTRO_CARD } from '@/constant/cypress';
import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';
import ProductModel from '@/models/product.model';
import StoreModel from '@/models/store.model';

import BestSellerProductCard from './bestSellerProductCard';
import IntroHeader from './introHeader';
import ProductInfo from './productInfo';
import RateInfo from './rateInfo';

type IntroCardProps = Pick<StoreModel, 'name' | 'description' | 'logo'> & {
  product: ProductModel | undefined;
};

export default function IntroCard({ name, description, logo, product }: IntroCardProps) {
  const { store: storeLocalization } = pageLevelLocalization;

  return (
    <Card
      data-cy={DATA_CY_STORE_INTRO_CARD}
      noBorder
      className={cn('relative z-0 mx-6 justify-start self-start  p-6 lg:mx-0 lg:p-8')}
    >
      <IntroHeader name={name} description={description} logo={logo} />
      {product && (
        <Container className='mt-6 flex flex-col-reverse gap-8 lg:grid lg:grid-cols-[2fr_90px_60px]'>
          <BestSellerProductCard product={product} />
          <Container className='item-center flex justify-evenly  lg:flex-col'>
            <Container className='relative'>
              <ProductInfo
                title={product.saleAmount}
                subTitle={storeLocalization.successful_sale}
              />
              <XImage
                alt='guarantee'
                width={70}
                height={70}
                src={imagesList.icons.guarantee}
                className='absolute left-2 top-0 -z-10 lg:hidden'
              />
            </Container>
            <RateInfo product={product} storeLocalization={storeLocalization} />
          </Container>
          <Container className='mt-12 hidden items-start justify-start lg:flex lg:flex-1'>
            <XImage alt='guarantee' width={70} height={60} src={imagesList.icons.guarantee} />
          </Container>
        </Container>
      )}
    </Card>
  );
}
